import { render } from "./BlogGiftsForDifficultPeopleView.vue?vue&type=template&id=3149b60e"
import script from "./BlogGiftsForDifficultPeopleView.vue?vue&type=script&lang=js"
export * from "./BlogGiftsForDifficultPeopleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__